import { zonedTimeToUtc } from "date-fns-tz";

const timezone = (): Date => zonedTimeToUtc(new Date(), "Europe/Helsinki");

export default timezone;
